import clsx from 'clsx';
import SeperatorStyle from './css/Seperator.module.css';
import { CSSProperties } from 'react';

type SeperatorProps = {
    direction?: "horizontal" | "vertical" | "garo" | "sero";
    size?: number;
    variant?: "solid" | "dashed" | "dotted";
    color?: string;
    fullSize?: boolean;
    strokeWidth?: number;
    style?: CSSProperties;
};

function Seperator({ direction = "horizontal", size = 100, variant = "solid", color = "rgba(238, 238, 238, 1)", fullSize = true, strokeWidth = 1, style }: SeperatorProps) {
    const isHorizontal = direction === "horizontal" || direction === "garo";
    
    // alignSelf: stretch가 적용된 경우 해당 축의 크기를 auto로 설정
    const hasStretch = style?.alignSelf === 'stretch';
    
    const width = isHorizontal ? `${fullSize ? "100%" : `${size}%`}` : `${strokeWidth}px`;
    const height = !isHorizontal 
        ? (hasStretch ? 'auto' : `${fullSize ? "100%" : `${size}%`}`)
        : `${strokeWidth}px`;
    
    const borderStyle = isHorizontal 
        ? { borderTop: `${strokeWidth}px ${variant} ${color}` }
        : { borderLeft: `${strokeWidth}px ${variant} ${color}` };
    
    return (
        <div className={clsx(
                SeperatorStyle.seperator,
            )}
            style={{
                width,
                height,
                ...borderStyle,
                ...style,
            }}></div>
    )
}

export default Seperator;